import React, { useState } from "react";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import WhatsAppModal from "./WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { buildWhatsAppUrl, getCurrentUrlWithUtmDefaults, getUtmParams } from "../../config/whatsappConfig";
import { sendToTecnom } from "../../config/tecnomApi";

const WhatsAppFlotante = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const utms = getUtmParams();
      await updateData({
        ...values,
        ...utms,
        url: window.location.href,
      });
      setOpen(false);
      const urlWithUtm = getCurrentUrlWithUtmDefaults();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `'Hola, estoy viendo opciones en Automont Gac y quiero tomar una mejor decisión , ¿me orientás?'\n${urlWithUtm}`;

      // Enviar lead a Tecnóm (WhatsApp modal)
      try {
        await sendToTecnom({
          brand: "GAC",
          name: values.nombre,
          email: values.email,
          phone: values.celular,
          comments: "Consulta desde modal de WhatsApp",
          tipoPlan: "venta directa",
          utm_source: utms.utm_source,
          utm_medium: utms.utm_medium,
          utm_campaign: utms.utm_campaign,
          campaign: "GAC_WHATSAPP_MODAL",
        });
      } catch (tecnomError) {
        console.error("Error al enviar a Tecnóm:", tecnomError);
      }

      window.location.href = buildWhatsAppUrl(whatsappMessage);
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;

